import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	max-width: 930px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	gap: 100px;

	padding: 50px 20px;
	color: ${CSSVars.black};

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 100px 40px;
	}

	ul {
		list-style: disc;
		padding-left: 10px;
	}

	ol {
		list-style: decimal;
		padding-left: 10px;
	}

	.text-section,
	.table-wrapper {
		h3 {
			font-size: ${CSSVars.fontSizeXL};
			margin-bottom: 10px;

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSize2XL};
			}
		}

		.p {
			font-size: ${CSSVars.fontSizeMD};

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeLG};
			}
		}
	}

	.card-helper-wrapper {
		height: fit-content;
		width: fit-content;
		position: relative;
		width: 100%;

		.throwing-stars {
			display: none;
		}
		.sword {
			display: none;
		}

		&.highlight {
			.throwing-stars {
				display: block;
				position: absolute;
				transform: scale(0.8);
				bottom: -58px;
				left: -50px;
				z-index: 1;
			}

			.sword {
				display: block;
				transform: scale(0.8);
				position: absolute;
				z-index: 1;
				top: -75px;
				right: -10px;
			}
		}

		.banner {
			padding: 40px;
			background: ${CSSVars.white};
			border: 1px solid ${CSSVars.gray50};
			border-radius: 10px;
			text-align: center;
			z-index: 20;
			position: relative;
			font-size: ${CSSVars.fontSizeMD};

			a {
				background-color: transparent;
				border: none;
				color: black;

				&:hover {
					color: ${CSSVars.blue};
				}
			}

			ul,
			ol {
				margin: 0 auto;
				width: fit-content;
			}

			.banner-text {
				margin-top: 10px;
				text-align: center;
			}

			.trustpilot-container {
				max-width: 350px;

				display: flex;
				align-items: center;
				justify-content: space-between;
				gap: 20px;
				flex-wrap: wrap;
				margin: 30px auto 0;

				img {
					max-width: 100%;
					height: 100%;
				}

				p {
					font-size: ${CSSVars.fontSizeMD};
				}
			}

			&.align-left {
				text-align: left;

				.trustpilot-container {
					margin: 30px 0 0;
				}

				ul,
				ol {
					margin: unset;
					width: fit-content;
				}
				.banner-text {
					text-align: left;
				}
			}

			h3 {
				font-size: ${CSSVars.fontSizeLG};

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeXL};
				}
			}

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				padding: 50px;
				font-size: ${CSSVars.fontSizeLG};
			}
		}
	}

	table {
		color: ${CSSVars.black};
		margin: 30px auto 0;
		border-collapse: collapse;
		table-layout: fixed;

		max-width: 100%;
		width: 100%;

		@media screen and (max-width: ${CSSVars.breakpointSM}) {
			width: 100%;
			display: block;
			overflow-x: auto;
		}

		thead {
			position: sticky;
			top: 0;
			background-color: ${CSSVars.white};
			box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05);

			&.has-inner-nav {
				top: 65px;
			}

			th {
				&:nth-child(1) {
					border-left: none;
					&:not(.first-td) {
						text-align: left;
						vertical-align: bottom;
						width: 25%;

						@media screen and (min-width: ${CSSVars.breakpointXL}) {
							width: 35%;
						}
					}
				}

				&:last-child {
					border-right: none;
				}
			}

			tr {
				&:last-of-type {
					border-bottom: 1px solid ${CSSVars.gray300};
				}
			}
		}

		tr {
			overflow: scroll;

			&:last-of-type {
				border-bottom: 2px solid white;
			}

			ul,
			ol {
				list-style: none;
			}

			&.align-left {
				td {
					vertical-align: baseline;

					&:not(:first-child),
					&.first-td {
						text-align: left;
					}
				}
			}
		}

		td {
			padding: 20px;
			border: 1px solid ${CSSVars.gray300};
			vertical-align: middle;

			&:nth-child(1) {
				border-left: none;
				&:not(.first-td) {
					font-size: ${CSSVars.fontSizeSM};
				}
			}
			&:last-child {
				border-right: none;
			}

			&:not(:first-child),
			&.first-td {
				text-align: center;
				font-size: ${CSSVars.fontSizeMD};

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeLG};
				}
			}

			.note {
			}

			.checked {
				font-size: 34px;
				color: ${CSSVars.blue};
			}

			.x {
				width: 18px;
				color: ${CSSVars.gray300};
			}
		}

		th {
			border: 1px solid ${CSSVars.gray300};
			border-top: none;
			border-bottom: none;
			padding: 20px;

			font-size: ${CSSVars.fontSizeLG};

			@media screen and (min-width: ${CSSVars.breakpointMD}) {
				font-size: ${CSSVars.fontSizeXL};
			}

			p {
				margin: 10px 10px 20px;
				color: ${CSSVars.blue};
				font-size: ${CSSVars.fontSizeMD};

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: ${CSSVars.fontSizeXL};
				}

				span {
					font-size: ${CSSVars.fontSizeXS};

					@media screen and (min-width: ${CSSVars.breakpointMD}) {
						font-size: ${CSSVars.fontSizeSM};
					}
				}
			}

			button {
				margin: 0 auto;
				padding: 6px 10px;
				font-size: 12px;

				@media screen and (min-width: ${CSSVars.breakpointMD}) {
					font-size: 14px;
					padding: 8px 20px;
				}
			}
		}
	}
`;
